import React, { useState, useEffect } from "react";
import "./WorkWithUs.css";

function WorkWithUs() {
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [pageInfo, setPageInfo] = useState({ title: "", description: "", footnote: "" });

  useEffect(() => {
    fetch("https://indodeftech.com/api/workwithus")
      .then((response) => response.json())
      .then((data) => {
        setJobs(data.jobs || []);
        setPageInfo(data.page || {});
        document.title = data.page?.title || "Work With Us - IndoDef Tech";
      })
      .catch((err) => console.error("Failed to load jobs:", err));
  }, []);

  const openForm = (job) => {
    setSelectedJob(job);
    document.getElementById("applyModal").style.display = "block";
  };

  const closeForm = () => {
    document.getElementById("applyModal").style.display = "none";
    setSelectedJob(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append("job_title", selectedJob?.title || "General");

    try {
      const res = await fetch("https://indodeftech.com/api/submitApplication", {
        method: "POST",
        body: formData,
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("Invalid JSON response:", text);
        throw new Error("Server returned invalid JSON");
      }

      if (data.success) {
        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
          closeForm();
        }, 2000);
        e.target.reset();
      } else {
        alert(data.error || "Failed to submit application.");
      }
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  return (
    <div className="work-container w3-animate-opacity">
      <header className="work-header w3-center">
        <h2>{pageInfo.title || "Work With Us"}</h2>
        <p>{pageInfo.description || "Join our growing team at IndoDef Tech!"}</p>
      </header>

      <div className="w3-row-padding work-grid">
        {jobs.length > 0 ? (
          jobs.map((job) => (
            <div key={job.id} className="w3-col l4 m6 s12 w3-margin-bottom">
              <div className="w3-card w3-padding w3-hover-shadow job-card">
                <h3>{job.title}</h3>
                <p className="job-meta">
                  <strong>Experience:</strong> {job.experience} <br />
                  <strong>Location:</strong> {job.location}
                </p>
                <p>{job.description}</p>
                <button
                  className="w3-button w3-border w3-round w3-hover-blue apply-btn"
                  onClick={() => openForm(job)}
                >
                  Apply Now
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="w3-center w3-padding">
            <p>Loading job openings...</p>
          </div>
        )}
      </div>

      <div className="w3-center w3-margin-top">
        <p>{pageInfo.footnote || "Don’t see a role that fits you? Send your resume to hr@indodeftech.com"}</p>
      </div>

      {/* ✅ Modal */}
      <div id="applyModal" className="w3-modal">
        <div className="w3-modal-content w3-animate-top w3-round-large" style={{ maxWidth: "500px" }}>
          <header className="w3-container w3-blue w3-round-top">
            <span onClick={closeForm} className="w3-button w3-display-topright w3-hover-red">&times;</span>
            <h3>Apply for {selectedJob?.title}</h3>
          </header>
          <div className="w3-container w3-padding">
u000            <form onSubmit={handleSubmit}>
              <p><label><b>Name</b></label><input className="w3-input w3-border w3-round" name="name" required /></p>
              <p><label><b>Email</b></label><input className="w3-input w3-border w3-round" type="email" name="email" required /></p>
              <p><label><b>Resume (PDF or DOC)</b></label><input className="w3-input w3-border w3-round" type="file" name="resume" accept=".pdf,.doc,.docx" required /></p>
              <p><label><b>Message</b></label><textarea className="w3-input w3-border w3-round" name="message" rows="3"></textarea></p>
              <div className="w3-center w3-margin-top">
                <button className="w3-button w3-blue w3-round-large" type="submit">Submit Application</button>
                <button type="button" onClick={closeForm} className="w3-button w3-border w3-round-large w3-margin-left">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {showSuccess && (
        <div className="w3-modal" style={{ display: "block" }}>
          <div className="w3-modal-content w3-round-large w3-animate-opacity w3-center" style={{ maxWidth: "350px", padding: "30px" }}>
            <h4 className="w3-text-green">✅ Application Submitted!</h4>
            <p>Thank you for applying. Our HR team will contact you soon.</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default WorkWithUs;
